// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchPopUp_wrapper__IU4s8","products":"SearchPopUp_products__9QwC9"};